import * as Yup from 'yup';

export const CustomUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be less than 50 characters')
    .required('First name is required'),
  lastName: Yup.string()
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be less than 50 characters')
    .required('Last name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number'
    )
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Please confirm password'),
  role: Yup.string()
  .oneOf(['user'], 'Role must always be user')
  .required('Role is required'),
  apiQuota: Yup.number()
    .min(1, 'API quota must be at least 1')
    .max(1000000, 'API quota must be less than 1,000,000')
    .required('API quota is required'),
  durationDays: Yup.number()
    .min(1, 'Duration must be at least 1 day')
    .max(365, 'Duration must be less than 365 days')
    .required('Duration is required'),
  verifyDirectly: Yup.boolean()
});